/**
 * Yields to the event loop without going through requestAnimationFrame or a timer.
 *
 * Long ingest loops have to hand control back so the UI can update, but rAF is
 * throttled hard (down to ~1 Hz) whenever the page is not visibly animating, and
 * background timers get clamped to a second. A message-channel round trip is
 * neither throttled nor clamped, so it stays sub-millisecond.
 */
export function yieldToEventLoop(): Promise<void> {
  return new Promise((resolve) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = () => {
      channel.port1.close();
      resolve();
    };
    channel.port2.postMessage(0);
  });
}

/** Resolves on the next animation frame. Only for work that must land before a paint. */
export function nextAnimationFrame(): Promise<void> {
  return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}
